// extracted by mini-css-extract-plugin
export default {"main-section__1":"Section1_main-section__1__YaDBy","main-section__1__services":"Section1_main-section__1__services__1fkcz","image":"Section1_image__zlrwf"};